/** Production Auth currently allows this exact URL, without query parameters. */
export function passwordRecoveryURL(origin: string): string {
  const url = new URL(origin);
  const local = ["localhost", "127.0.0.1"].includes(url.hostname);
  // Keep development links local; production aliases use the registered canonical domain.
  return `${local ? url.origin : "https://tickethall.com"}/recuperar-senha`;
}
